// extracted by mini-css-extract-plugin
module.exports = {"icon":"breadcrumbs-arrow_icon__7gfOW"};